import React from 'react';
import Api from "../../servicios/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes, faArrowRight, faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import Swal from "sweetalert2";
class Pacientes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            pagina: [],
            pacientes: [],empresas: [],
            cedula: "",
            nombres: "",
            apellido1: "",
            apellido2: "",
            telefono: "",
            email: "",errores: [],
            regimen: "",nacimiento:"",
        }
    }
    resetForm() {
        document.getElementById('bnombre').value = "";
        document.getElementById('bidentificacion').value = "";
        document.getElementById('bnombre').focus();
        this.BuscarPaciente(1);
    }
    enviarPaciente = (sidp,doc, snombre, sapellido,dir) => {
        console.log(sidp, snombre, sapellido);
        document.getElementById('id_paciente').value = sidp;
        document.getElementById('doc').value = doc;
        document.getElementById('direccion_paciente').value = dir;
        document.getElementById('nombre_paciente').value = snombre + " " + sapellido;
        //this.props.agregarPaciente(sidp, snombre + " " + sapellido);
        window.$('#asignarPaciente').modal('hide');
    }
      cargarEmpresas() {
        fetch(Api + "Empresas")
            .then(respuesta => respuesta.json())
            .then((datosEmpresas) => {
                //console.log(datosEmpresas.data);
                this.setState({ empresas: datosEmpresas.data })
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.cargarEmpresas(1);
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    BuscarPaciente(page) {
        let bnombre = document.getElementById('bnombre').value;
        let bidentificacion = document.getElementById('bidentificacion').value;
        console.log("Formulario Enviado...");
        if (bnombre == '') {
            bnombre = 0;
        }
        if (bidentificacion == '') {
            bidentificacion = 0;
        }
        fetch(Api + "SearchPacientes/" + bidentificacion + "/" + bnombre + "/0?page=" + page)
            .then((respuesta) => respuesta.json())
            .then((datosRespuesta) => {
                this.setState({ datosCargados: true, pacientes: datosRespuesta.data, pagina: datosRespuesta.total, ultimo: datosRespuesta.last_page, actual: datosRespuesta.current_page });
            })
            .catch(console.log);
    }
    GuardarPaciente = (e) => {
            e.preventDefault();
            const { cedula, nombres, apellido1, apellido2, telefono, email, regimen,sexo,nacimiento } = this.state;
            
            var errores = [];
            if (!cedula) errores.push("error_cedula");
            if (!nombres) errores.push("error_nombres");
            if (!apellido1) errores.push("error_apellido1");
            if (!telefono) errores.push("error_telefono");
            if (!regimen) errores.push("error_regimen");
            if (!sexo) errores.push("error_sexo");
            if (!nacimiento) errores.push("error_nacimiento");
            this.setState({ errores: errores });
            
            if (errores.length > 0) {
                return false;
            }
    
            let form = document.getElementById('form_paciente');
            let formData = new FormData(form);
            
            fetch(Api + "AddPacientes", {
                method: "POST",
                body: formData
            })
            .then(respuesta => respuesta.json())
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.fire(
                    'Pacientes!',
                    datosRespuesta.msj,
                    'success'
                )
                this.limpiarformulario();
                window.$('#nuevoPacienteSub').modal('hide');
                // Si necesitas actualizar la lista de pacientes después de agregar uno nuevo
                if (this.props.actualizarLista) {
                    this.props.actualizarLista();
                }
            })
            .catch(function(error) {
                Swal.fire(
                    'Verifica haber llenado los campos',
                    '',
                    'error'
                )
            });
        }
         limpiarformulario = () => {
        this.setState({
            cedula: "",
            nombres: "",
            apellido1: "",
            apellido2: "",
            telefono: "",
            email: "",
            regimen: "",sexo: "",nacimiento:"",
            errores: [],
        });
    }
    render() {
        const { datosCargados, pacientes, pagina, ultimo, empresas,cedula, nombres, apellido1, apellido2, telefono, email, regimen,sexo,nacimiento } = this.state;
        if (!datosCargados) {
            var load = 'Cargando datos....';
        } else {
            var load = '';
        }
        return (
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="nuevaEnfermedad1Label">Crear Pacientes</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="card">
                            <div style={{ backgroundImage: 'linear-gradient(#2FB3FB, #003153)', color: '#FFFFFF', borderTopLeftRadius: 5, borderTopRightRadius: 5 }} className="card-header text-center">
                                <h5 style={{ fontSize: 18 }} >Lista de Pacientes</h5>
                            </div>
                            <div className='card-body'>
                                <form id="form_paciente">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label htmlFor="cedula" className="form-label">Cédula</label>
                                        <input 
                                            type="text" 
                                            className={`form-control ${this.verificarError("error_cedula") ? "is-invalid" : ""}`} 
                                            id="cedula" 
                                            name="cedula" 
                                            value={cedula} 
                                            onChange={this.cambioValor}
                                            required
                                        />
                                        <div className="invalid-feedback">Ingrese la cédula</div>
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <label htmlFor="nombres" className="form-label">Nombre</label>
                                        <input 
                                            type="text" 
                                            className={`form-control ${this.verificarError("error_nombres") ? "is-invalid" : ""}`} 
                                            id="nombres" 
                                            name="nombres" 
                                            value={nombres} 
                                            onChange={this.cambioValor}
                                            required
                                        />
                                        <div className="invalid-feedback">Ingrese el nombre</div>
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <label htmlFor="apellido1" className="form-label">Primer Apellido</label>
                                        <input 
                                            type="text" 
                                            className={`form-control ${this.verificarError("error_apellido1") ? "is-invalid" : ""}`} 
                                            id="apellido1" 
                                            name="apellido1" 
                                            value={apellido1} 
                                            onChange={this.cambioValor}
                                            required
                                        />
                                        <div className="invalid-feedback">Ingrese el primer apellido</div>
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <label htmlFor="apellido2" className="form-label">Segundo Apellido</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="apellido2" 
                                            name="apellido2" 
                                            value={apellido2} 
                                            onChange={this.cambioValor}
                                        />
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <label htmlFor="telefono" className="form-label">Teléfono</label>
                                        <input 
                                            type="tel" 
                                            className={`form-control ${this.verificarError("error_telefono") ? "is-invalid" : ""}`} 
                                            id="telefono" 
                                            name="telefono" 
                                            value={telefono} 
                                            onChange={this.cambioValor}
                                            required
                                        />
                                        <div className="invalid-feedback">Ingrese el teléfono</div>
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            id="email" 
                                            name="email" 
                                            value={email} 
                                            onChange={this.cambioValor}
                                        />
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <label htmlFor="regimen" className="form-label">Régimen</label>
                                        <select 
                                            className={`form-select ${this.verificarError("error_regimen") ? "is-invalid" : ""}`} 
                                            id="regimen" 
                                            name="regimen" 
                                            value={regimen} 
                                            onChange={this.cambioValor}
                                            required
                                        >
                                             <option value="">Seleccionar</option>
                                    <option value="1">01 Contributivo cotizante</option>
                                    <option value="2">02 Contributivo beneficiario</option>
                                    <option value="3">03 Contributivo adicional</option>
                                    <option value="4">04 Subsidiado</option>
                                    <option value="5">05 No afiliado</option>
                                    <option value="6">06 Especial o Excepción cotizante</option>
                                    <option value="7">07 Especial o Excepción beneficiario</option>
                                    <option value="8">08 Personas privadas de la libertad a cargo del Fondo Nacional de Salud</option>
                                    <option value="9">09 Tomador / Amparado ARL</option>
                                    <option value="10">10 Tomador / Amparado SOAT</option>
                                    <option value="11">11 Tomador / Amparado Planes voluntarios de salud</option>
                                    <option value="12">12 Particular</option>
                                    <option value="13">13 Especial o Excepción no cotizante Ley 352 de 1997</option>
                                        </select>
                                        <div className="invalid-feedback">Seleccione el régimen</div>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="sexo" className="form-label">Sexo</label>
                                        <select 
                                            className={`form-select ${this.verificarError("error_sexo") ? "is-invalid" : ""}`} 
                                            id="sexo" 
                                            name="sexo" 
                                            value={sexo} 
                                            onChange={this.cambioValor}
                                            required
                                        >
                                            <option value="">Seleccione...</option>
                                            <option value="F">Femenino</option>
                                            <option value="M">Masculino</option>
                                          
                                        </select>
                                        <div className="invalid-feedback">Seleccione el régimen</div>
                                    </div>
                                     <div className="col-md-6">
                                        <label htmlFor="email" className="form-label">Fecha de Cumpleaño</label>
                                        <input 
                                            type="date" 
                                             className={`form-control ${this.verificarError("error_nacimiento") ? "is-invalid" : ""}`} 
                                            id="nacimiento" 
                                            name="nacimiento" 
                                            value={nacimiento} 
                                            onChange={this.cambioValor}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                                                        <label htmlFor="empresa" className="form-label">Empresa:</label>
                                                                        <select
                                                                            className={((this.verificarError("error_empresa")) ? "is-invalid" : "") + " form-control form-select-sm"}
                                                                            id="empresa"
                                                                            name="empresa"
                                                                            title="EMPRESA"
                                                                            onChange={this.cambioValor}
                                                                        >
                                                                            <option value="">Seleecionar</option>
                                                                            {
                                                                                empresas.map(itemEmpresa => (
                                                                                    <option key={itemEmpresa.id_empresa} value={itemEmpresa.rips}>{itemEmpresa.nombre_emp}</option>
                                                                                ))
                                                                            }
                                                                        </select>
                                                                    </div>
                                </div>
                            </form>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={this.GuardarPaciente}>Guardar</button>
                        </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Pacientes;